import Grid from "@mui/material/Grid";
import Fields from "./Fields";
import Typography from "@mui/material/Typography";

export default function FormPeopleDetails() {
	const section = "people";

	return (
		<Grid container spacing={2} sx={{ width: "100%" }}>
			<Grid item xs={12}>
				<h2>{`People > Details`}</h2>
			</Grid>
			<Grid item xs={12}>
				<h3>Fields</h3>
				<Typography sx={{ width: "33%", flexShrink: 0 }}>
					Personal Details
				</Typography>
				<Typography sx={{ color: "text.secondary" }}>
					Step: 'people.details'
				</Typography>
				<Fields title="" source={`${section}.details`} />
			</Grid>
		</Grid>
	);
}
